import React from 'react';
import { Box, Typography } from '@mui/material';
import PaidIcon from '@mui/icons-material/Paid';
import AutoStoriesIcon from '@mui/icons-material/AutoStories';
import TungstenIcon from '@mui/icons-material/Tungsten';

export const SummaryTariff: React.FC = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        alignItems: 'center',
        justifyContent: 'center',
        gap: '20px',
        mt: '30px',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          border: '1px solid #E9E8E7',
          borderRadius: '8px',
          p: '16px',
        }}
      >
        <PaidIcon sx={{ color: '#5A5959' }} />
        <Typography component="span" sx={{ fontSize: '16px', fontWeight: 600, color: '#5A5959' }}>
          Tarifário
        </Typography>
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          border: '1px solid #E9E8E7',
          borderRadius: '8px',
          p: '16px',
        }}
      >
        <AutoStoriesIcon sx={{ color: '#5A5959' }} />
        <Typography component="span" sx={{ fontSize: '16px', fontWeight: 600, color: '#5A5959' }}>
          Termos e condições de uso
        </Typography>
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          border: '1px solid #E9E8E7',
          borderRadius: '8px',
          p: '16px',
        }}
      >
        <TungstenIcon sx={{ color: '#5A5959' }} />
        <Typography component="span" sx={{ fontSize: '16px', fontWeight: 600, color: '#5A5959' }}>
          Dicas
        </Typography>
      </Box>
    </Box>
  );
};
